<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { usePackaging } from "@/composables/usePackaging"
import NBRadioGroup from "@/app/Checkout/components/common/NBRadioGroup/index.vue"

const { wrappingOptions, selectedWrappingOption } = usePackaging()
</script>